<template>
    <div class="edit-doorphone-info">
        <div v-if="doorphone.physical_status === 6" class="edit-doorphone-info__alert edit-doorphone-info__alert--warning">
          <v-icon left small>mdi-alert-outline</v-icon>
          Домофон без устройства, ожидает монтажа.
        </div>
        <div v-if="doorphone.physical_status === 5" class="edit-doorphone-info__alert edit-doorphone-info__alert--warning">
          <v-icon left small>mdi-alert-outline</v-icon>
          Установлен домофон старого образца. Ключи под заказ.
        </div>
        <div v-if="formDoorphone.hiddenFromAppList" class="edit-doorphone-info__alert edit-doorphone-info__alert--warning">
          <v-icon left small>mdi-eye-off-outline</v-icon>
          Домофон скрыт у абонентов в мобильном приложении и не отображается в списке активированных устройств.
        </div>
        <div v-if="formDoorphone.hidder" class="edit-doorphone-info__alert edit-doorphone-info__alert--warning">
          <v-icon left small>mdi-eye-off-outline</v-icon>
          Домофон скрыт из списка регистрации (активации) в мобильном приложении.
        </div>
        <v-form ref="formEditDoorphone" v-model="valid" lazy-validation>
        <v-row>
            <v-col cols="12" md="5">
            <div class="edit-doorphone-info__section">
              <h2 class="edit-doorphone-info__section-title">
                <v-icon left small>mdi-information-outline</v-icon>
                Данные о домофоне
              </h2>
            <v-row v-if="roleName !== 'master'" class="edit-doorphone-info__form-row">
                <v-col cols="12" class="edit-doorphone-info__col">
                <v-combobox
                    v-model="formDoorphone.address"
                    @keyup="startTypingTimer"
                    @input="updateAddressSearch"
                    ref="addressInput"
                    prepend-inner-icon="mdi-rename-box-outline"
                    :rules="rules.universal"
                    :items="isFirstLoading ? [formDoorphone.address] : addresses"
                    item-text="addresses"
                    return-object
                    flat
                    label="Адрес"
                    outlined
                    dense
                ></v-combobox>
                </v-col>

                <v-col cols="12" sm="10" class="py-0" v-if="isMainDoorphone">
                <v-text-field
                    label="Номер подъеда"
                    v-model='formDoorphone.entrance'
                    :rules='rules.requiredNumber'
                    type="number"
                    prepend-inner-icon="mdi-home-modern"
                    outlined
                    dense
                    flat
                    required
                    :disabled="true"
                ></v-text-field>
                </v-col>

                <v-col cols="12" sm="10" class="py-0" v-if="isMainDoorphone">
                <v-text-field
                    label="От квартиры"
                    v-model='formDoorphone.fromApartment'
                    :rules='rules.number'
                    type="number"
                    prepend-inner-icon="mdi-arrow-down-bold-box-outline"
                    outlined
                    dense
                    flat
                    required
                    :disabled="!['admin', 'agent', 'admin-engineer'].includes(this.roleName)"
                ></v-text-field>
                </v-col>

                <v-col cols="12" sm="10" class="py-0" v-if="isMainDoorphone">
                <v-text-field
                    label="До квартиры"
                    v-model='formDoorphone.toApartment'
                    :rules='rules.number'
                    type="number"
                    prepend-inner-icon="mdi-arrow-up-bold-box-outline"
                    outlined
                    dense
                    flat
                    required
                    :disabled="!['admin', 'agent', 'admin-engineer'].includes(this.roleName)"
                ></v-text-field>
                </v-col>

                <v-col cols="12" sm="10" class="py-0" v-if="isMainDoorphone">
                <v-text-field
                    label="Диспетчерская"
                    disabled
                    v-model='formDoorphone.conciergeNumber'
                    type="number"
                    prepend-inner-icon="mdi-rename-box-outline"
                    outlined
                    dense
                    flat
                    required
                ></v-text-field>
                </v-col>

                <v-col cols="12" sm="10" class="py-0">
                  <v-autocomplete
                    label="Район (только для г. Саранск)"
                    v-model='formDoorphone.region'
                    :items="district"
                    :item-text="item => (item.name) + ' (' + displayCity(item.city_id) + ')'"
                    item-value="id"
                    prepend-inner-icon="mdi-map-marker-radius-outline"
                    type="string"
                    outlined
                    :disabled="!isDistrict"
                    dense
                    flat
                  />
                </v-col>
                <v-col cols="12" sm="10" class="py-0">
                  <v-autocomplete
                    label="Участок МТО"
                    v-model="formDoorphone.mto_sector_id"
                    :items="mtoSectorOptions"
                    :item-text="item => item.service_area_name ? `${item.name} (${item.service_area_name})` : item.name"
                    item-value="id"
                    prepend-inner-icon="mdi-map-marker-radius-outline"
                    outlined
                    dense
                    flat
                    clearable
                  />
                </v-col>
                <v-col cols="12" sm="10" class="py-0">
                  <v-autocomplete
                    label="Управляющая компания"
                    :items="managementCompanies"
                    v-model='formDoorphone.managementCompany'
                    @change="setGroupManagement"
                    item-text="name"
                    prepend-inner-icon="mdi-home-account"
                    item-value="id"
                    type="string"
                    outlined
                    dense
                    flat
                    clearable
                  />
                </v-col>
              <v-col cols="12" sm="10" class="py-0">
                <v-text-field
                  label="Компания-собственник"
                  v-model='formDoorphone.groupManagement'
                  type="string"
                  prepend-inner-icon="mdi-shield-account"
                  outlined
                  dense
                  flat
                  disabled
                ></v-text-field>
              </v-col>
                <v-col cols="12" sm="10" class="py-0">
                  <v-select
                    label="Оплата мобильного приложения"
                    :items="paymentTypes"
                    v-model='formDoorphone.paymentType'
                    v-if="formDoorphone.physical_status !== 5"
                    :rules="formDoorphone.physical_status !== 5 ? rules.universal : []"
                    item-text="payment_type"
                    prepend-inner-icon="mdi-credit-card-outline"
                    item-value="id"
                    :disabled="doorphone.type === 'G'"
                    outlined
                    dense
                    flat
                  />
                </v-col>
                <v-col cols="12" sm="10" class="py-0">
                  <v-text-field
                    label="Комментарий"
                    v-model='formDoorphone.comment'
                    type="name"
                    prepend-inner-icon="mdi-comment-outline"
                    outlined
                    dense
                    flat
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="10" class="py-0">
                  <v-textarea
                    label="Технический комментарий"
                    v-model="formDoorphone.technical_comment"
                    prepend-inner-icon="mdi-tools"
                    outlined
                    dense
                    flat
                    auto-grow
                    rows="2"
                    placeholder="IP, версия прошивки, заметки по настройке"
                    :disabled="!isTechnicalCommentEditable"
                  />
                </v-col>
              <v-col cols="12" sm="10" class="py-0" v-if="isMainDoorphone">
                <v-text-field
                  label="Тариф за услугу 'Домофон'"
                  prepend-inner-icon="mdi-file-document-edit-outline"
                  v-model='formDoorphone.tariff'
                  outlined
                  dense
                  flat
                  required
                  suffix="руб. в месяц"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="10" class="py-0" v-if="isMainDoorphone">
                <v-autocomplete
                  label="Возможность установки трубки"
                  prepend-inner-icon="mdi-phone-hangup"
                  :items="tubeInstallation"
                  item-text="name"
                  item-value="id"
                  v-model='formDoorphone.installationTube'
                  @change="setInstallationTube"
                  type="string"
                  outlined
                  dense
                  flat
                />
              </v-col>
              <v-col cols="12" sm="10" class="py-0" v-if="isMainDoorphone">
                <v-text-field
                  label="Стоимость установки трубки"
                  prepend-inner-icon="mdi-cash-100"
                  v-model='formDoorphone.phone_setup_cost'
                  type="number"
                  :disabled="!isPhoneSetupCost"
                  outlined
                  dense
                  flat
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="10" class="py-0" v-if="isMainDoorphone">
                <v-select
                  label="Оплата за услугу домофон"
                  prepend-inner-icon="mdi-file-document-edit-outline"
                  :items="contractTypes"
                  v-model='formDoorphone.contract_type'
                  item-text="contract_type"
                  item-value="id"
                  clearable
                  outlined
                  dense
                  flat
                  required
                ></v-select>
              </v-col>
              <v-col v-if="doorphone.device_id" cols="12" sm="10" class="py-0">
                <v-autocomplete
                  label="Физический статус"
                  prepend-inner-icon="mdi-progress-clock"
                  :items="physicalStatus"
                  v-model='formDoorphone.physical_status'
                  item-text="status"
                  item-value="id"
                  clearable
                  outlined
                  dense
                  flat
                  required
                ></v-autocomplete>
              </v-col>
              <v-col v-if="formDoorphone.physical_status === 5" cols="12" sm="10" class="py-0">
                <v-autocomplete
                  label="Физическое устройство (старого образца)"
                  :items="oldIntercoms"
                  v-model='formDoorphone.oldDeviceName'
                  prepend-inner-icon="mdi-cog-outline"
                  item-text="text"
                  item-value="text"
                  outlined
                  dense
                  flat
                ></v-autocomplete>
              </v-col>
              <v-col v-if="!doorphone.device_id" cols="12" sm="10" class="py-0">
                <v-autocomplete
                  label="Физический статус"
                  prepend-inner-icon="mdi-progress-clock"
                  :items="physicalStatusWithoutDevice"
                  v-model='formDoorphone.physical_status'
                  item-text="status"
                  item-value="id"
                  :disabled="doorphone.physical_status === 6"
                  outlined
                  dense
                  flat
                  :hide-details="doorphone.physical_status === 5"
                ></v-autocomplete>
                <div class="mb-2 mt-2" v-if="doorphone.physical_status === 5">
                  <span style="color: blue;">
                      Чтобы присвоить устройство и дать возможность продавать ключи, измените физический статус на
                      "Ожидает монтажа". Обратите внимание, что перейти обратно с "Ожидает монтажа" на "Старый домофон" невозможно.
                  </span>
                </div>
              </v-col>
              <v-col cols="12" sm="10" class="py-0" v-if="isMainDoorphone">
                <v-autocomplete
                  label="Бесплатные ключи"
                  prepend-inner-icon="mdi-cloud-key-outline"
                  :items="freeKeys"
                  v-if="formDoorphone.physical_status !== 5"
                  v-model='formDoorphone.free_keys'
                  :rules="formDoorphone.physical_status !== 5 ? rules.universal : []"
                  item-text="text"
                  item-value="id"
                  clearable
                  outlined
                  dense
                  flat
                  required
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="10" class="py-0" v-if="isMainDoorphone && !doorphone.mainDoorphones[0]">
                <v-autocomplete
                  label="Выдача бесплатных ключей"
                  prepend-inner-icon="mdi-account-key-outline"
                  :items="issuanceFreeKeys"
                  v-if="doorphone.physical_status !== 5"
                  v-model='formDoorphone.issuance_free_keys'
                  item-text="text"
                  item-value="id"
                  clearable
                  outlined
                  dense
                  flat
                  required
                ></v-autocomplete>
              </v-col>
                <v-col v-if="this.roleName === 'admin'" cols="12" class="py-0">
                  <v-checkbox
                    v-model="formDoorphone.hidder"
                    :disabled="!doorphone.device_id"
                    label="Скрыть для регистрации в мобильном приложении"
                    hide-details
                    dense
                    color="success"
                  />
                </v-col>
              <v-col v-if="this.roleName === 'admin' && doorphone.type !== 'G'" cols="12" class="py-0">
                  <v-checkbox
                    v-model="formDoorphone.hiddenFromAppList"
                    :disabled="!doorphone.device_id"
                    label="Скрыть из списка активированных домофонов абонента в мобильном приложении"
                    hide-details
                    dense
                    color="success"
                  />
                </v-col>
              <v-col
                v-if="formDoorphone.hiddenFromAppList && doorphone.additionalEntrances.length > 0"
                cols="12"
                class="py-0"
              >
                <div style="color: #ff5252">
                  У данного домофона есть дополнительный вход. Не забудьте также скрыть его из списка, если требуется.
                </div>
              </v-col>
              <v-col cols="12" class="mx-auto">
                <edit-gate
                :intercom-manufacturer="doorphone.manufacturer"/>
              </v-col>
            </v-row>
              <v-row v-else>
                <v-col cols="12" sm="10" class="py-0 pt-5">
                  <v-text-field
                    label="Комментарий"
                    v-model='formDoorphone.comment'
                    type="name"
                    prepend-inner-icon="mdi-comment-outline"
                    outlined
                    dense
                    flat
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="10" class="py-0">
                  <v-textarea
                    label="Технический комментарий"
                    v-model="formDoorphone.technical_comment"
                    prepend-inner-icon="mdi-tools"
                    outlined
                    dense
                    flat
                    auto-grow
                    rows="2"
                    placeholder="IP, версия прошивки, заметки по настройке"
                    :disabled="!isTechnicalCommentEditable"
                  />
                </v-col>
                <v-col cols="12" sm="10" class="py-0" v-if="isMainDoorphone">
                  <v-autocomplete
                    label="Возможность установки трубки"
                    prepend-inner-icon="mdi-phone-hangup"
                    :items="tubeInstallation"
                    item-text="name"
                    item-value="id"
                    v-model='formDoorphone.installationTube'
                    @change="setInstallationTube"
                    type="string"
                    outlined
                    dense
                    flat
                  />
                </v-col>
              </v-row>
            </div>
            </v-col>
            <v-col cols="12" md="7">
            <div v-if="currentDevice" class="edit-doorphone-info__current-device">
              <v-icon left color="success">mdi-check-circle-outline</v-icon>
              {{ currentDevice }}
            </div>
            <div class="edit-doorphone-info__card mt-3" :class="{ 'edit-doorphone-info__card--disabled': doorphone.physical_status === 5 }">
                <div class="edit-doorphone-info__filters">
                  <div class="edit-doorphone-info__filters-title">
                    <v-icon left small>mdi-devices</v-icon>
                    Устройства
                  </div>
                  <div class="edit-doorphone-info__filters-row">
                    <v-text-field
                      v-model="searchDevice"
                      label="Поиск по IP-адресу"
                      outlined
                      dense
                      hide-details
                      class="edit-doorphone-info__field"
                      autocomplete="off"
                      @keyup="(e) => e.keyCode === 13 && filterDevices()"
                    />
                    <v-btn
                      color="primary"
                      class="text-none edit-doorphone-info__search-btn"
                      dark
                      rounded
                      @click.prevent="filterDevices"
                    >
                      <v-icon left>mdi-magnify</v-icon>
                      Поиск
                    </v-btn>
                  </div>
                </div>
                <v-data-table
                  class="edit-doorphone-info__table"
                  v-model="selectedDevices"
                  :options.sync="universalOptions"
                  :server-items-length="universalTotalDevices"
                  :headers="headersDevices"
                  :items="devices"
                  item-key="id"
                  show-select
                  :footer-props="{ 'items-per-page-options': [10, 20, 50, 100] }"
                  :single-select="true"
                  :disable-sort="true"
                />
                <div class="edit-doorphone-info__table-actions">
                  <v-btn
                    v-if="!displayDownloadSound && roleName !== 'master'"
                    :disabled="doorphone.physical_status === 6 || doorphone.physical_status === 5"
                    color="success"
                    class="text-none"
                    dark
                    rounded
                    @click="downloadSoundDoor()"
                  >
                    <v-icon left>mdi-download</v-icon>
                    Скачать звук открытия двери
                  </v-btn>
                  <v-btn
                    v-if="!displayDownloadSoundBeep && roleName !== 'master'"
                    color="success"
                    class="text-none"
                    dark
                    rounded
                    :disabled="doorphone.physical_status === 6 || doorphone.physical_status === 5"
                    @click="downloadSoundBeep()"
                  >
                    <v-icon left>mdi-download</v-icon>
                    Скачать звук гудка
                  </v-btn>
                  <v-btn
                    v-if="$checkPermission('change_device_doorphone')"
                    color="success"
                    class="text-none"
                    dark
                    rounded
                    :disabled="doorphone.physical_status === 5"
                    @click="uploadDevice()"
                  >
                    <v-icon left>mdi-swap-horizontal</v-icon>
                    Сменить устройство
                  </v-btn>
                  <v-btn
                    v-if="$checkPermission('change_agent_doorphone')"
                    color="success"
                    class="text-none"
                    dark
                    rounded
                    :disabled="doorphone.physical_status === 6 || doorphone.physical_status === 5"
                    @click.prevent="popupAgent = true"
                  >
                    <v-icon left>mdi-account-switch</v-icon>
                    Изменить агента
                  </v-btn>
                </div>
            </div>
              <v-dialog
                v-model="popupAgent"
                max-width="500"
                lazy-validation
                persistent
              >
                <v-card>
                  <v-card-title class="headline">Изменение агента</v-card-title>
                  <v-form ref="changeAgent">
                    <v-col cols="12" class="pb-0">
                      <v-autocomplete
                        label="Агент"
                        :items="agents"
                        v-model='formDoorphone.agent'
                        hint="При смене агента универсальные ключи нужно будет добавлять заново!"
                        item-text="name"
                        item-value="id"
                        type="string"
                        persistent-hint
                        outlined
                        dense
                        flat
                      />
                    </v-col>
                    <v-card-actions>
                      <div class="mx-auto">
                        <v-btn
                          large
                          color="success"
                          class="text-none"
                          dense
                          @click.prevent="saveAgent()"
                          :loading="isUpdatedAgent"
                        >
                          Сохранить
                        </v-btn>
                        <v-btn
                          large
                          class="ma-2 text-none"
                          outlined
                          dense
                          hide-details
                          color="error"
                          @click.prevent="popupAgent = false"
                          :loading="isUpdatedAgent"
                        >
                          Отменить
                        </v-btn>
                      </div>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-dialog>
            <div v-if="doorphone.physical_status !== 6 && doorphone.physical_status !== 5" class="edit-doorphone-info__section mt-4">
              <h2 class="edit-doorphone-info__section-title">Изображение с домофона</h2>
              <v-img
                :src="doorphone.snapshot"
                max-width="400"
                contain
                class="edit-doorphone-info__image image-doorphone"
                @click.stop="dialogImage = true"
                alt="Изображение отсутствует"
              />
              <v-dialog v-model="dialogImage" :max-width="isMobile ? '90%' : '50%'" content-class="dialog-border-radius">
                <v-card>
                  <v-card-actions class="justify-end pa-2">
                    <v-btn icon @click="dialogImage = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-actions>
                  <v-img :src="doorphone.snapshot" max-width="100%" alt="" @click="dialogImage = false" />
                </v-card>
              </v-dialog>
            </div>
            </v-col>
        </v-row>

        <v-divider class="my-4" />

        <div class="edit-doorphone-info__actions">
          <div class="edit-doorphone-info__actions-left">
            <v-btn
              color="primary"
              class="text-none"
              rounded
              @click="validate()"
            >
              <v-icon left>mdi-content-save-outline</v-icon>
              Сохранить
            </v-btn>
            <v-btn
              color="primary"
              outlined
              class="text-none"
              rounded
              @click.prevent="returnDoorphone"
            >
              <v-icon left>mdi-close</v-icon>
              Отменить
            </v-btn>
          </div>
          <v-btn
            v-if="$checkPermission('destroy_doorphone')"
            color="error"
            outlined
            class="text-none"
            rounded
            @click.stop="dialog = true"
          >
            <v-icon left>mdi-delete-outline</v-icon>
            Удалить домофон
          </v-btn>
        </div>

        <v-dialog v-model="dialog" persistent :retain-focus="false" max-width="500" content-class="dialog-border-radius">
          <BaseDeleteModal
            :active.sync="dialog"
            @close="dialog = false"
            @submit="removeDoorphone()"
            messageTitle="Удалить домофон?"
            messageText="Подтверждая, вы удалите домофон."
            confirmText="Удалить"
            cancelText="Отмена"
            confirmColor="error"
          />
        </v-dialog>
        </v-form>

      <v-dialog v-model="errorDialog" max-width="500" persistent>
        <v-card>
          <v-card-title class="headline">Ошибки при смене устройства</v-card-title>
          <v-card-text>
            <div v-for="(error, index) in errorMessages" :key="index">
              {{ error }}
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="CloseDealogErrorMessages">Закрыть</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import {
  rules,
  headersDevices,
  paymentTypes,
  contractTypes,
  physicalStatus,
  physicalStatusWithoutDevice,
  oldIntercoms,
  freeKeys,
  issuanceFreeKeys,
  tubeInstallation,
} from '../../consts';
import EditGate from './components/EditGate';
import BaseDeleteModal from '@/components/BaseDeleteModal';
import watchTableOptions from '../../../../../mixins/watchTableOptions';

export default {
  name: 'GeneralInfo',
  components: { EditGate, BaseDeleteModal },
  mixins: [watchTableOptions],
  props: ['returnDoorphone'],
  data: () => {
    return {
      EditGate,
      isFirstLoading: true,
      baseUrl: process.env.VUE_APP_API_URL,
      rules,
      dialog: false,
      universalOptions: {
        itemsPerPage: 10,
        page: 1,
        sortBy: [],
        sortDesc: [],
      },
      universalTotalDevices: 0,
      selectedDevices: [],
      managementCompanies: [],
      agents: [],
      oldIntercoms,
      headersDevices,
      tubeInstallation,
      dialogImage: false,
      isPhoneSetupCost: true,
      isDistrict: false,
      valid: true,
      popupAgent: false,
      isUpdatedAgent: false,
      searchDevice: '',
      currentDevice: '',
      popupAddress: false,
      manufacturer: '',
      paymentTypes,
      contractTypes,
      physicalStatus,
      physicalStatusWithoutDevice,
      errorDialog: false,
      errorMessages: [],
      freeKeys,
      issuanceFreeKeys,
      searchAddress: '',
      typingTimer: null,
      formDoorphone: {
        address: {
          addresses: '',
        },
        entrance: '',
        conciergeNumber: '',
        comment: '',
        technical_comment: '',
        paymentType: '',
        fromApartment: '',
        toApartment: '',
        region: null,
        hidder: false,
        hiddenFromAppList: false,
        oldDeviceName: '',
        tariff: '',
        phone_setup_cost: '',
        installationTube: '',
        contract_type: '',
        managementCompany: '',
        groupManagement: '',
        agent: '',
        mto_sector_id: null,
        physical_status: '',
        free_keys: '',
        issuance_free_keys: '',
      },
      isMobile: false,
    };
  },
  computed: {
    ...mapGetters({
      cities: 'Doorphone/cities',
      streets: 'Doorphone/streets',
      houses: 'Doorphone/houses',
      district: 'Doorphone/districts',
      doorphone: 'Doorphone/doorphoneEditDoorphone',
      doorphoneInfo: 'Doorphone/doorphoneEditInfo',
      addresses: 'Doorphone/addresses',
      devices: 'Device/devices',
      roleName: 'roleName',
    }),
    isMainDoorphone () {
      return ['M', 'A'].includes(this.doorphone.type);
    },
    displayDownloadSound () {
      return ['Beward'].includes(this.manufacturer) && this.$checkPermission('download_open_door_sound_doorphone');
    },
    displayDownloadSoundBeep () {
      return this.manufacturer === 'Beward' && this.$checkPermission('download_ring_sound_doorphone');
    },
    snapshotUrl () {
      const s = this.doorphone?.snapshot;
      if (!s) return '';
      if (/^https?:\/\//i.test(s)) return s;
      const base = (this.baseUrl || '').replace(/\/$/, '');
      const path = (s || '').replace(/^\//, '');
      return base ? `${base}/${path}` : s;
    },
    isTechnicalCommentEditable () {
      return ['admin', 'admin-engineer'].includes(this.roleName);
    },
    mtoSectorOptions () {
      return this.doorphoneInfo.mto_sectors || [];
    },
  },
  mounted () {
    if (window.innerWidth < 600) {
      this.isMobile = true;
    }
    this.formDoorphone.region = this.doorphone.region_name;
  },
  watch: {
    universalOptions (curr, prev) {
      this.handleOptionsChange(curr, prev, () => {
        this.universalChangePage();
      });
    },
  },
  created () {
    // device
    if (this.doorphone.ip_address) {
      this.currentDevice = 'Текущее устройство: ' + this.doorphone.ip_address;
    } else {
      this.currentDevice = 'Домофон без устройства.';
    }
    this.addresses[0] = this.doorphone.address;
    this.formDoorphone.address.addresses = this.doorphone.address;
    this.formDoorphone.entrance = this.doorphone.entrance;
    this.formDoorphone.conciergeNumber = this.doorphone.concierge_number;
    this.formDoorphone.comment = this.doorphone.comment;
    this.formDoorphone.technical_comment = this.doorphone.technical_comment || '';
    this.formDoorphone.paymentType = this.doorphone.payment_type;
    this.formDoorphone.oldDeviceName = this.doorphone.old_device_name;
    this.formDoorphone.fromApartment = this.doorphone.diapason_from;
    this.formDoorphone.toApartment = this.doorphone.diapason_to;
    this.formDoorphone.region = this.doorphone.region_name;
    this.formDoorphone.hidder = this.doorphone.hidden;
    this.formDoorphone.hiddenFromAppList = this.doorphone.hidden_from_app_list;
    this.formDoorphone.tariff = this.doorphone.tariff;
    this.formDoorphone.phone_setup_cost = this.doorphone.phone_setup_cost;
    this.formDoorphone.contract_type = this.doorphone.contract_type;
    this.formDoorphone.physical_status = this.doorphone.physical_status;
    this.managementCompanies = this.doorphoneInfo.management_companies;
    this.agents = this.doorphoneInfo.agents;
    if (this.isMainDoorphone && !this.doorphone.mainDoorphones[0]) {
      this.formDoorphone.free_keys = this.doorphone.free_keys;
      this.formDoorphone.issuance_free_keys = this.doorphone.issuance_free_keys;
    }
    this.formDoorphone.agent = this.doorphone.agent_id;
    this.formDoorphone.mto_sector_id = this.doorphone.mto_sector_id || null;

    if (this.doorphone.management_company_id) {
      this.formDoorphone.managementCompany = this.doorphone.management_company_id;
    }
    if (this.doorphone.possibility_phone_setup === 'N') {
      this.isPhoneSetupCost = false;
    }
    if (this.doorphone.possibility_phone_setup) {
      this.formDoorphone.installationTube = this.doorphone.possibility_phone_setup;
    }
    if (this.doorphone.management_group_name) {
      this.formDoorphone.groupManagement = this.doorphone.management_group_name;
    }

    this.manufacturer = this.doorphone.manufacturer;

    setTimeout(() => this.$nextTick(() => {
      this.isFirstLoading = false;
    }));
    const filters = {
      free: 1,
      type: 'D', // для домофонов
    };

    if (this.doorphone.agent_id) {
      filters.agent_id = this.doorphone.agent_id;
    }

    this.applyChangeDeviceModelFilter(filters);
    this.loadDevices({
      filters,
      pagination: 1,
      limit: this.universalOptions.itemsPerPage,
    })
      .then((response) => {
        this.universalTotalDevices = response.meta.total;
      });
  },
  methods: {
    ...mapActions({
      updateDoorphone: 'Doorphone/updateDoorphone',
      getDoorsound: 'Doorphone/getDoorsound',
      loadDevices: 'Device/getDevices',
      getRingsound: 'Doorphone/getRingsound',
      changeDevice: 'Doorphone/changeDevice',
      loadCities: 'Doorphone/getCities',
      loadStreets: 'Doorphone/getStreets',
      loadHouses: 'Doorphone/getHouses',
      loadAllAgents: 'Agents/loadAllAgents',
      changeAgent: 'Doorphone/changeAgent',
      deleteDoorphone: 'Doorphone/deleteDoorphone',
      getAddressSearch: 'Doorphone/getAddressSearch',
    }),
    CloseDealogErrorMessages () {
      this.errorDialog = false;
    },
    setInstallationTube (idTube) {
      const possibilityTube = this.tubeInstallation.find(item => item?.id === idTube);
      this.isPhoneSetupCost = possibilityTube.id !== 'N';
    },
    updateAddressSearch () {
      const val = this.formDoorphone.address;
      if (val && this.isDistrict) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(() => {
          if (!this.isFirstLoading && val) {
            this.getAddressSearch({
              value: val,
            })
              .then((res) => {
                this.formDoorphone.region = null;
                this.isDistrict = !!res.districts[0];
              });
          }
        }, 600);
      }
    },
    startTypingTimer (val) {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(() => {
        if (!this.isFirstLoading && val.srcElement._value) {
          this.getAddressSearch({
            value: val.srcElement._value,
          })
            .then((res) => {
              this.formDoorphone.region = null;
              this.isDistrict = !!res.districts[0];
            });
        }
      }, 600);
    },
    setGroupManagement (groupCompanyId) {
      const company = this.managementCompanies.find(item => item?.id === groupCompanyId);
      if ((company) && (company.management_group) && (company.management_group.name)) {
        this.formDoorphone.groupManagement = company.management_group.name;
      } else {
        this.formDoorphone.groupManagement = '';
      }
    },
    displayCity (item) {
      switch (item) {
        case 1: return 'Ульяновск';
        case 2: return 'Саранск';
        default: return '';
      }
    },
    filterDevices () {
      this.universalOptions.page = 1;
      this.universalChangePage();
    },
    universalChangePage () {
      const filters = {
        free: 1,
        type: 'D', // для домофонов
      };

      if (this.doorphone.agent_id) {
        filters.agent_id = this.doorphone.agent_id;
      }

      this.applyChangeDeviceModelFilter(filters);

      if (this.searchDevice) {
        filters.ip_address = this.searchDevice;
      }

      this.loadDevices({
        pagination: 1,
        limit: this.universalOptions.itemsPerPage,
        page: this.universalOptions.page,
        filters,
      })
        .then((response) => {
          this.universalTotalDevices = response.meta.total;
        });
    },
    /**
     * Фильтр свободных устройств для смены модели.
     * DKS15134 → можно заменить на DKS15134 или DKS20211.
     */
    applyChangeDeviceModelFilter (filters) {
      if (!this.doorphone.device_id) {
        return;
      }

      if (this.doorphone.manufacturer === 'Rubetek') {
        filters['model.manufacturer.name'] = this.doorphone.manufacturer;
        return;
      }

      if (this.doorphone.model === 'DKS15134') {
        filters['model.name'] = 'DKS15134,DKS20211';
        return;
      }

      if (this.doorphone.model === 'DKS20211') {
        filters['model.name'] = 'DKS20211';
        return;
      }

      if (this.doorphone.model) {
        filters['model.name'] = this.doorphone.model;
      }
    },
    saveAgent () {
      this.isUpdatedAgent = true;
      this.changeAgent({
        id: this.$route.params.id,
        agentId: this.formDoorphone.agent,
      }).then(() => {
        this.$flash_success('Изменения успешно сохранены');
      })
        .catch(() => {
          this.$flash_warning('Ошибка при изменении агента');
        })
        .finally(() => {
          this.popupAgent = false;
          this.isUpdatedAgent = false;
        });
    },
    removeDoorphone () {
      this.deleteDoorphone({ id: this.$route.params.id })
        .then(() => {
          if (this.isMainDoorphone) {
            this.$router.push({ name: 'Doorphone' });
          } else {
            this.$router.push({ name: 'Gates' });
          }
          this.$router.push({ name: 'Doorphone' });
          this.$flash_success('Домофон успешно удалёно');
        })
        .catch(() => {
          this.$flash_warning('Ошибка при удалении домофона');
        });
      this.dialog = false;
    },
    uploadDevice () {
      if (!this.selectedDevices.length) {
        this.$flash_warning('Выберите устройство из списка');
      } else {
        const tempDevice = this.selectedDevices[0].id;
        this.changeDevice({
          doorphoneId: this.$route.params.id,
          deviceId: tempDevice,
        })
          .then((response) => {
            if (response.errors && response.errors.length > 0) {
              this.errorMessages = response.errors;
              this.errorDialog = true;
            }
            if (this.doorphone.physical_status === 6 || this.doorphone.physical_status === 5) {
              this.validate(true);
            }
            this.$flash_success('Изменения сохранены');
          })
          .catch((err) => {
            if (err && err.length > 0) {
              this.errorMessages = err;
              this.errorDialog = true;
            }
            if (this.doorphone.physical_status === 6 || this.doorphone.physical_status === 5) {
              this.validate(true);
            }
            this.$flash_warning('Возможно устройство не в сети');
          });
      }
    },
    downloadSoundBeep () {
      this.getRingsound(this.$route.params.id)
        .then((response) => {
          this.downloadSound(response, 'Ringsound.wav');
        })
        .catch(() => {
          this.$flash_warning('Ошибка при скачивании');
        });
    },
    downloadSoundDoor () {
      this.getDoorsound(this.$route.params.id)
        .then((response) => {
          this.downloadSound(response, 'Doorsound.wav');
        })
        .catch(() => {
          this.$flash_warning('Ошибка при скачивании');
        });
    },
    downloadSound (response, fileName) {
      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const fileLink = document.createElement('a');

      fileLink.href = fileURL;
      fileLink.setAttribute('download', fileName);
      document.body.appendChild(fileLink);

      fileLink.click();
    },
    async validate (withoutRedirection) {
      if (this.roleName !== 'master') {
        await this.$refs.addressInput.blur();
      }
      let tempDevice;
      if (!this.selectedDevices.length) {
        // device
        tempDevice = this.doorphone.device_id;
      } else {
        tempDevice = this.selectedDevices[0].id;
      }

      if (this.$refs.formEditDoorphone.validate()) {
        const tempDoorphone = {
          diapason_from: +this.formDoorphone.fromApartment,
          diapason_to: +this.formDoorphone.toApartment,
          hidden: this.formDoorphone.hidder,
          hidden_from_app_list: this.formDoorphone.hiddenFromAppList,
        };
        if (tempDevice) {
          tempDoorphone.device_id = tempDevice;
        }
        if (this.formDoorphone.region && this.isDistrict) {
          tempDoorphone.region_id = this.formDoorphone.region;
        }
        if (this.formDoorphone.managementCompany) {
          tempDoorphone.management_company_id = this.formDoorphone.managementCompany;
        }
        if (this.formDoorphone.mto_sector_id !== undefined) {
          tempDoorphone.mto_sector_id = this.formDoorphone.mto_sector_id;
        }
        if (typeof this.formDoorphone.address === 'object') {
          tempDoorphone.address = this.formDoorphone.address.addresses;
        } else {
          tempDoorphone.address = this.formDoorphone.address;
        }
        // tempDoorphone.concierge_number = this.formDoorphone.conciergeNumber;
        tempDoorphone.comment = this.formDoorphone.comment;
        if (this.isTechnicalCommentEditable) {
          tempDoorphone.technical_comment = this.formDoorphone.technical_comment
            ? this.formDoorphone.technical_comment
            : null;
        }
        tempDoorphone.tariff = this.formDoorphone.tariff;
        tempDoorphone.contract_type = this.formDoorphone.contract_type;
        tempDoorphone.old_device_name = this.formDoorphone.oldDeviceName;
        if (withoutRedirection) {
          tempDoorphone.physical_status = 4; // Пусконаладка
        } else {
          tempDoorphone.physical_status = this.formDoorphone.physical_status;
        }
        tempDoorphone.payment_type = this.formDoorphone.paymentType;
        if (this.isMainDoorphone && this.formDoorphone.free_keys) {
          tempDoorphone.free_keys = this.formDoorphone.free_keys;
        }
        if (this.isMainDoorphone && this.formDoorphone.issuance_free_keys) {
          tempDoorphone.issuance_free_keys = this.formDoorphone.issuance_free_keys;
        }
        if (this.formDoorphone.installationTube) {
          tempDoorphone.possibility_phone_setup = this.formDoorphone.installationTube;
        }
        if (this.formDoorphone.installationTube !== 'N') {
          tempDoorphone.phone_setup_cost = this.formDoorphone.phone_setup_cost;
        }
        if (this.formDoorphone.region === null && this.isDistrict) {
          this.$flash_danger('Заполните поле "Район"');
        } else {
          this.updateDoorphone({
            id: this.$route.params.id,
            doorphone: tempDoorphone,
          })
            .then(() => {
              this.$flash_success('Изменения успешно сохранены');
            })
            .catch((message) => {
              if (message.length > 0) {
                for (let i = 0; i < message.length; i++) {
                  this.$flash_warning(message[i]);
                  console.error(message);
                  this.$sentry_exception(message);
                }
              } else {
                this.$flash_warning('Ошибка при изменении информации о домофоне');
              }
            });
        }
      } else {
        this.$flash_danger('Заполните все поля');
      }
    },
  },
};

</script>

<style lang="scss" scoped>
.edit-doorphone-info__alert {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  border-radius: 8px;
  margin-bottom: 12px;
  font-size: 0.875rem;
}
.edit-doorphone-info__alert--warning {
  background: rgba(244, 67, 54, 0.08);
  border: 1px solid rgba(244, 67, 54, 0.25);
  color: #c62828;
}

.edit-doorphone-info__section {
  margin-bottom: 0;
}
.edit-doorphone-info__section-title {
  font-size: 1rem;
  font-weight: 500;
  color: #37474f;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
}
.edit-doorphone-info__form-row {
  margin: 0 -12px;
}
.edit-doorphone-info__col {
  padding-top: 0;
  padding-bottom: 12px;
}

.edit-doorphone-info__current-device {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: rgba(76, 175, 80, 0.08);
  border: 1px solid rgba(76, 175, 80, 0.3);
  border-radius: 12px;
  font-size: 0.9375rem;
  color: #2e7d32;
}

.edit-doorphone-info__card {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  overflow: hidden;
}
.edit-doorphone-info__card--disabled {
  opacity: 0.7;
  pointer-events: none;
}

.edit-doorphone-info__filters {
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.edit-doorphone-info__filters-title {
  font-size: 1rem;
  font-weight: 500;
  color: #37474f;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}
.edit-doorphone-info__filters-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.edit-doorphone-info__field {
  flex: 1;
  min-width: 200px;
}
.edit-doorphone-info__search-btn {
  flex-shrink: 0;
}
.edit-doorphone-info__table {
  border: none;
}
.edit-doorphone-info__table-actions {
  padding: 12px 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.edit-doorphone-info__image {
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
}
.image-doorphone {
  cursor: pointer;
}

.edit-doorphone-info__actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.edit-doorphone-info__actions-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

::v-deep .dialog-border-radius {
  border-radius: 12px;
}
</style>
